/**
 * @generated SignedSource<<05558453b38897159336a4f68ccae1de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "newsletterIds"
    }],
    v1 = [{
      "fields": [{
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "newsletterIds"
      }],
      "kind": "ObjectValue",
      "name": "filter"
    }, {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    v5 = [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }],
    v6 = {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": v5 /*: any*/,
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": v5 /*: any*/,
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": v5 /*: any*/,
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "hooksNewsletterQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "NewsletterConnection",
        "kind": "LinkedField",
        "name": "newsletters",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "NewsletterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v6 /*: any*/, v7 /*: any*/, v8 /*: any*/],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hooksNewsletterQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "NewsletterConnection",
        "kind": "LinkedField",
        "name": "newsletters",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "NewsletterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v6 /*: any*/, v7 /*: any*/, v8 /*: any*/, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "db6ce7df57fd46a0894ca1c99f5593c8",
      "id": null,
      "metadata": {},
      "name": "hooksNewsletterQuery",
      "operationKind": "query",
      "text": "query hooksNewsletterQuery(\n  $first: Int\n  $newsletterIds: [String]\n) {\n  newsletters(first: $first, filter: {entityIds: $newsletterIds}) {\n    edges {\n      node {\n        entityId\n        name\n        alternativeName\n        description {\n          text\n        }\n        summary {\n          text\n        }\n        homepageDescription {\n          text\n        }\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "07926024ff85778e6f495ad0f59ef656";
export default node;